import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import EventBus from "./EventBus";

const ResponseInterceptor = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.status === 401) {
          EventBus.dispatch("logout");
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);
  return null;
};

export default ResponseInterceptor;
